import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { resetAllDashboardFiltersThunk } from "../../redux/actions/homeAction";

/**
 * Resets dashboard filters only when the route becomes Home (/) after being on another screen.
 * Covers: sidebar / logo navigation to Home (push) and browser Back/Forward when React Router’s
 * pathname actually changes to /.
 *
 * We intentionally do NOT listen to window "popstate": same-document hash changes (e.g. internal
 * tabs using <a href="#...">) can fire popstate without a React route change and would wipe filters
 * on every tab/tile click across dashboards.
 */
const DashboardFilterResetListener = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const prevPathRef = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    const isHome = path === "/" || path === "";
    const prev = prevPathRef.current;
    if (isHome && prev != null && prev !== "/" && prev !== "") {
      dispatch(resetAllDashboardFiltersThunk());
    }
    prevPathRef.current = path;
  }, [location.pathname, dispatch]);

  return null;
};

export default DashboardFilterResetListener;
